<template>
  <div>
    <v-tabs
      v-model="active"
      color="primary"
      grow
      @change="tabChange"
    >
      <v-tab
        v-for="(option, index) in options"
        :key="index"
        class="activeTab"
        ripple
      >
        {{ option.name }}
      </v-tab>
      <v-tab-item
        v-for="(option, index) in options"
        :key="index"
      >
          <div v-if="option.component === 'PlantList'">
            <action-table v-show="level === 0" @refresh="refreshHandler" :actionEdit="true" :header="header" title="Plants" component="plant"
            :fields="componentField" :data="plist" @row-selection="handlePlantSelection"></action-table>
            <configuration v-show="level === 1" @back="level=0" section="plant" :isActive="activeComponent === 'plant' && level === 1" :plant="selectedPlant"></configuration>
          </div>
          <div v-if="option.component === 'UserList'">
            <action-table v-show="level === 0" @refresh="refreshHandler" :header="header" title="Users" component="user"
            :fields="componentField" :data="ulist" @row-selection="handlePlantSelection"></action-table>
            <configuration v-show="level === 1" @back="level=0" section="user" :isActive="activeComponent === 'user' && level === 1" :plant="selectedPlant"></configuration>
          </div>
          <div v-if="option.component === 'GlobalConfig'">
            <configuration section="global" :isActive="activeComponent === 'global'"></configuration>
          </div>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import Configuration from '@/components/admin/Configuration.vue'
import ActionTable from '@/components/admin/ActionTable.vue'
import ComponentConfigHelper from '@/helper/component_config/index.js'


export default {
  props: {
    options: {
      type: Array,
      required: true
    }
  },
  components: {
    Configuration,
    ActionTable
  },
  data() {
    return {
      level: 0,
      active: 0,
      selectedPlant: null,
      tabs: [{
        component: 'plant',
        level: 0
      }, {
        component: 'user',
        level: 0
      }, {
        component: 'global',
        level: 1
      }],
      header: [
        {
          text: 'Plant',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'Actions', value: 'action', icon:"edit", action:["edit"],  align: 'center', sortable: false }
      ],
    }
  },
  mounted() {
    if(this.isPlantListEmpty)
      this.fetchPlants()
  },
  computed: {
    ...mapGetters('admin', ['plantList', 'userList', 'isPlantListEmpty', 'isUserListEmpty']),
    plist() {
      return this.plantList()
    },
    ulist() {
      return this.userList(['name', 'user_id'])
    },
    activeComponentObj() {
      return this.tabs[this.active]
    },
    activeComponent() {
      return this.activeComponentObj.component
    },
    componentField() {
      return this.activeComponent && this.activeComponentObj.level === 0 ? ComponentConfigHelper.map[this.activeComponent].fields : []
    }
  },
  methods: {
    ...mapActions('admin', ['fetchPlants', 'fetchUsers']),
    handlePlantSelection(plant) {
      this.selectedPlant = plant.plant_id
      this.level = 1
    },
    refreshHandler() {
      if(this.activeComponent === 'plant') {
        this.fetchPlants()
      } else if(this.activeComponent === 'user') {
        this.fetchUsers()
      }
    },
    tabChange() {
      this.level = 0
      if(this.activeComponent === 'plant' && this.isPlantListEmpty) {
        this.fetchPlants()
      } else if(this.activeComponent === 'user' && this.isUserListEmpty) {
        this.fetchUsers()
      }
    },
  },
}
</script>

<style scoped>
  .activeTab:hover {
    background-color: var(--v-sixth-base);
  }
</style>